export type ContributionDay = {
  key: string
  label: string
  count: number
}

function getIntensityLevel(count: number, maxCount: number) {
  if (count === 0 || maxCount === 0) return 0

  const ratio = count / maxCount
  if (ratio > 0.75) return 4
  if (ratio > 0.5) return 3
  if (ratio > 0.25) return 2
  return 1
}

export function GitHubContributionGraph({
  days,
  startDayOfWeek,
}: {
  days: ContributionDay[]
  startDayOfWeek: number
}) {
  const maxCount = days.reduce((max, day) => Math.max(max, day.count), 0)
  const totalCells = startDayOfWeek + days.length
  const numColumns = Math.ceil(totalCells / 7)
  const placeholderCells = Array.from({ length: startDayOfWeek })

  return (
    <div
      className="grid gap-1.5 transition-colors xl:gap-1"
      style={{
        gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
        gridTemplateRows: 'repeat(7, 1fr)',
        gridAutoFlow: 'column',
      }}
      aria-hidden
    >
      {placeholderCells.map((_, index) => (
        <div key={`empty-${index}`} className="aspect-square" />
      ))}
      {days.map((day) => (
        <div
          key={day.key}
          className="contribution-cell aspect-square rounded-sm"
          data-intensity={getIntensityLevel(day.count, maxCount)}
          title={day.label}
        />
      ))}
    </div>
  )
}

export function ContributionLegend() {
  return (
    <div className="text-muted-foreground flex items-center gap-1 text-xs">
      <span>Less</span>
      {[0, 1, 2, 3, 4].map((index) => (
        <div key={index} className="contribution-legend-swatch h-3 w-3 rounded-sm" data-intensity={index} />
      ))}
      <span>More</span>
    </div>
  )
}
